<template>
    <div class="device-list">
        <el-table stripe ref="multipleTable" :data="sensordata" style="width: 100%" :show-header="false"
            :height="tableHeight">
            <el-table-column prop="name" show-overflow-tooltip>
                <template #default="{ row }">
                    <i class="cursor-pointer" :title="$t(equiIconConvert(row.deviceCatalog, row.deviceType).title)"
                        :class="equiIconConvert(row.deviceCatalog, row.deviceType).icon"></i>

                    <i v-icon:theme="['equiStatusConvert', row.deviceStatus]"></i>

                    <span :title="row.fullPath">{{ row.carrierDeviceName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="optare" align="center" width="60px">
                <template #default="{ row, $index }">
                    <i class="el-icon-tickets" style="margin-right:5px;cursor: pointer;" :title="$t('integration.details')"
                        @click="detailFn(row)"></i>
                    <i class="el-icon-view" :class="activeIndex === $index ? 'active-color' : ''" style="cursor: pointer;"
                        @click="handleView(row, $index)" :title="$t('integration.view_history')"></i>
                </template>
            </el-table-column>
        </el-table>
        <ProbeDetail></ProbeDetail>
    </div>
</template>

<script>
import bus from '@/utils/bus';
import { equiIconConvert } from "@/utils/convert";
import ProbeDetail from '@/components/dialog/probeDetail/ProbeDetail.vue';
export default {
    props: {
        sensordata: {
            type: Array,
            default: () => []
        },
        carrierInfo: {}
    },
    components: {
        ProbeDetail
    },
    watch: {
        sensordata() {
            this.activeIndex = '';
        }
    },
    computed: {
        equiIconConvert: () => equiIconConvert
    },
    data() {
        return {
            tableHeight: '100%',
            activeIndex: '',
            isView: true
        };
    },
    mounted() {
        bus.$on('dataValFn', val => {
            this.isView = val.length > 0;
        });
    },
    beforeDestroy() {
        bus.$off('dataValFn');
    },
    methods: {
        detailFn(row) {
            console.log(this.carrierInfo)
            bus.$emit('probeParam', {
                sceneId: this.carrierInfo.scene_id,
                carrierId: this.carrierInfo.id,
                probeCode: row.carrierDeviceCode,
                carrierType: this.carrierInfo.typeId
            })
            // const { href } = this.$router.resolve({
            //     path: '/SensorDetail',
            //     query: {
            //         id: row.id,
            //         name: row.tagId
            //     }
            // });
            // window.open(href, '_blank', 'height=800,width=1200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no');
        },
        handleView(row, index) {
            if (!this.isView) return this.$message.warning($t('integration.please_select_at_least_one_data'));
            this.activeIndex = index;
            // 展示设备点
            this.$emit('viewSensor', row);
            // // 获取设备点
            // bus.$emit('getSensor', row)
        }
    }
};
</script>

<style lang="scss" scoped>
.device-list {
    width: 220px;
    height: 100%;
    border-right: 1px solid #cccccc;

    .active-color {
        color: #344962;
        font-weight: bolder;
    }
}
</style>
